import { StepperTypeTokens, ColorTokens, } from '@voltmoney/schema';
export const stepperTypeTokensMap = {
    [StepperTypeTokens.HORIZONTAL]: {
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Black,
    },
    [StepperTypeTokens.VERTICAL]: {
        labelColor: ColorTokens.Black,
        bgColor: ColorTokens.White,
    },
    [StepperTypeTokens.PARTNER]: {
        labelColor: ColorTokens.Black,
        bgColor: ColorTokens.White,
    },
    [StepperTypeTokens.DISTRIBUTOR]: {
        labelColor: ColorTokens.Black,
        bgColor: ColorTokens.White,
    },
};
